import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';

export const getCafes = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.cafes
        .getCafes(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_CAFES_FAILED,
              reject: actionTypes.GET_CAFES_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_CAFES_LOADING);
  const success = res => action(actionTypes.GET_CAFES_SUCCESS, res);

  return request();
};

export const getAmenities = () => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.cafes
        .getAmenities()
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_AMENITIES_FAILED,
              reject: actionTypes.GET_AMENITIES_REJECT,
            }),
          );
        });
    };
  };
  const loading = () => action(actionTypes.GET_AMENITIES_LOADING);
  const success = res => action(actionTypes.GET_AMENITIES_SUCCESS, res);

  return request();
};

export const getRegions = (id, query) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.cafes
        .getRegions(id, query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_REGIONS_FAILED,
              reject: actionTypes.GET_REGIONS_REJECT,
            }),
          );
        });
    };
  };
  const loading = () => action(actionTypes.GET_REGIONS_LOADING);
  const success = res => action(actionTypes.GET_REGIONS_SUCCESS, res);

  return request();
};

export const getSpecialServices = () => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.cafes
        .getSpecialServices()
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_SPECIAL_SERVICES_FAILED,
              reject: actionTypes.GET_SPECIAL_SERVICES_REJECT,
            }),
          );
        });
    };
  };

  const loading = () => action(actionTypes.GET_SPECIAL_SERVICES_LOADING);
  const success = res => action(actionTypes.GET_SPECIAL_SERVICES_SUCCESS, res);

  return request();
};

export const insertCafe = cafeObject => {
  return dispatch => {
    dispatch(action(actionTypes.INSERT_NEW_CAFE_LOADING));
    return API.cafes
      .insertNewCafe(cafeObject)
      .then(res => dispatch(action(actionTypes.INSERT_NEW_CAFE_SUCCESS, res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.INSERT_NEW_CAFE_FAILED,
            reject: actionTypes.INSERT_NEW_CAFE_REJECT,
          }),
        );
        throw err;
      });
  };
};

export const getCafeById = cafeId => {
  return dispatch => {
    dispatch(action(actionTypes.GET_CAFE_BY_ID_LOADING));
    return API.cafes
      .getCafeById(cafeId)
      .then(res => dispatch(action(actionTypes.GET_CAFE_BY_ID_SUCCESS, res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_CAFE_BY_ID_FAILURE,
            reject: actionTypes.GET_CAFE_BY_ID_REJECT,
          }),
        );
      });
  };
};

export const updateCafe = cafeObject => {
  return dispatch => {
    dispatch(action(actionTypes.UPDATE_CAFE_LOADING));
    return API.cafes
      .updateCafe(cafeObject)
      .then(res => dispatch(action(actionTypes.UPDATE_CAFE_SUCCESS, res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.UPDATE_CAFE_FAILED,
            reject: actionTypes.UPDATE_CAFE_REJECT,
          }),
        );
        throw err;
      });
  };
};

export const clearAddOrEditCafeForm = () => {
  return action(actionTypes.CLEAR_ADD_OR_EDIT_CAFE_FORM);
};

export const fetchAllCafeUsers = cafeId => {
  return dispatch => {
    dispatch(action(actionTypes.FETCH_ALL_CAFE_USERS_LOADING));
    return API.users
      .fetchAllCafeUsers(cafeId)
      .then(res =>
        dispatch(action(actionTypes.FETCH_ALL_CAFE_USERS_SUCCESSFULL, res)),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.FETCH_ALL_CAFE_USERS_FAILURE,
            reject: actionTypes.FETCH_ALL_CAFE_USERS_REJECT,
          }),
        );
      });
  };
};

export const fetchSearchedCafeUser = search => {
  return dispatch => {
    dispatch(action(actionTypes.FETCH_CAFE_SEARCHED_USER_LOADING));
    return API.users
      .fetchSearchedUsers(search)
      .then(res =>
        dispatch(action(actionTypes.FETCH_CAFE_SEARCHED_USER_SUCCESSFULL, res)),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.FETCH_CAFE_SEARCHED_USER_FAILURE,
            reject: actionTypes.FETCH_CAFE_SEARCHED_USER_REJECT,
          }),
        );
      });
  };
};

export const assignUserToCafe = assignUserObject => {
  return dispatch => {
    dispatch(action(actionTypes.ASSIGN_USER_TO_CAFE_LOADING));
    return API.users
      .assignUserToCafe(assignUserObject)
      .then(res =>
        dispatch(action(actionTypes.ASSIGN_USER_TO_CAFE_SUCCESSFULL, res)),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.ASSIGN_USER_TO_CAFE_FAILED,
            reject: actionTypes.ASSIGN_USER_TO_CAFE_REJECT,
          }),
        );
      });
  };
};

export const changeCafeStatus = (cafeId, status) => {
  return dispatch => {
    dispatch(action(actionTypes.CHANGE_CAFE_STATUS_LOADING));
    return API.cafes
      .changeCafeStatus(cafeId, status)
      .then(res =>
        dispatch(action(actionTypes.CHANGE_CAFE_STATUS_SUCCESS, res)),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.CHANGE_CAFE_STATUS_FAILED,
            reject: actionTypes.CHANGE_CAFE_STATUS_REJECT,
          }),
        );
      });
  };
};

export const deleteCafeUser = userId => {
  return dispatch => {
    dispatch(action(actionTypes.DELETE_CAFE_USER_LOADING));
    return API.cafes
      .deleteCafeUser(userId)
      .then(res => dispatch(action(actionTypes.DELETE_CAFE_USER_SUCCESS, res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.DELETE_CAFE_USER_FAILED,
            reject: actionTypes.DELETE_CAFE_USER_REJECT,
          }),
        );
      });
  };
};

export const fetchCafeUserDetails = userId => {
  return dispatch => {
    dispatch(action(actionTypes.FETCH_CAFE_USER_DETAILS_LOADING));
    return API.cafes
      .fetchCafeUserDetails(userId)
      .then(res =>
        dispatch(action(actionTypes.FETCH_CAFE_USER_DETAILS_SUCCESS, res)),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.FETCH_CAFE_USER_DETAILS_FAILED,
            reject: actionTypes.FETCH_CAFE_USER_DETAILS_REJECT,
          }),
        );
      });
  };
};

export const updateCafeUser = (userId, roleId) => {
  return dispatch => {
    dispatch(action(actionTypes.UPDATE_CAFE_USER_LOADING));
    return API.cafes
      .updateCafeUser(userId, roleId)
      .then(res => dispatch(action(actionTypes.UPDATE_CAFE_USER_SUCCESS, res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.UPDATE_CAFE_USER_FAILED,
            reject: actionTypes.UPDATE_CAFE_USER_REJECT,
          }),
        );
      });
  };
};

export const getCafeByIdForAdmin = () => {
  return dispatch => {
    dispatch(action(actionTypes.GET_CAFE_BY_ID_FOR_ADMIN_LOADING));
    return API.cafes
      .getCafeByIdForAdmin()
      .then(res =>
        dispatch(action(actionTypes.GET_CAFE_BY_ID_FOR_ADMIN_SUCCESS, res)),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_CAFE_BY_ID_FOR_ADMIN_FAILED,
            reject: actionTypes.GET_CAFE_BY_ID_FOR_ADMIN_REJECT,
          }),
        );
      });
  };
};

export const updateCafeImagesAndLogoForAdmin = imagesAndLogoObject => {
  return dispatch => {
    dispatch(action(actionTypes.UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_LOADING));
    return API.cafes
      .updateCafeImagesAndLogoForAdmin(imagesAndLogoObject)
      .then(res =>
        dispatch(
          action(
            actionTypes.UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_SUCCESS,
            res,
          ),
        ),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_FAILED,
            reject: actionTypes.UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_REJECT,
          }),
        );
      });
  };
};

export const fetchCafeDiscountDetailsById = id => {
  return dispatch => {
    dispatch(action(actionTypes.FETCH_CAFE_DISCOUNT_BY_ID_LOADING));
    return API.cafes
      .fetchCafeDiscountDetailsById(id)
      .then(res =>
        dispatch(action(actionTypes.FETCH_CAFE_DISCOUNT_BY_ID_SUCCESS, res)),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.FETCH_CAFE_DISCOUNT_BY_ID_FAILED,
            reject: actionTypes.FETCH_CAFE_DISCOUNT_BY_ID_REJECT,
          }),
        );
      });
  };
};

export const getAllCafeNamesForPanel = cityCode => {
  return dispatch => {
    dispatch(action(actionTypes.GET_ALL_CAFE_NAMES_FOR_PANEL_LOADING));
    return API.cafes
      .getAllCafeNamesForPanel(cityCode)
      .then(res =>
        dispatch(action(actionTypes.GET_ALL_CAFE_NAMES_FOR_PANEL_SUCCESS, res)),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_ALL_CAFE_NAMES_FOR_PANEL_FAILED,
            reject: actionTypes.GET_ALL_CAFE_NAMES_FOR_PANEL_REJECT,
          }),
        );
      });
  };
};

export const getAllCafeContract = () => {
  return dispatch => {
    dispatch(action(actionTypes.GET_CAFES_CONTRACT_LOADING));
    return API.cafes
      .getAllCafeContract()
      .then(res =>
        dispatch(action(actionTypes.GET_CAFES_CONTRACT_SUCCESS, res)),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_CAFES_CONTRACT_FAILED,
            reject: actionTypes.GET_CAFES_CONTRACT_REJECT,
          }),
        );
      });
  };
};

export const getCafesExcelFile = query => {
  return function(dispatch) {
    dispatch(action(actionTypes.GET_CAFES_EXCEL_FILE_LOADING));

    return API.cafes
      .getCafesExcelFile(query)
      .then(res => {
        dispatch(action(actionTypes.GET_CAFES_EXCEL_FILE_SUCCESS));

        return res;
      })
      .catch(err => {
        console.log(err);

        const errAction = generateErrorAction(err, {
          failure: actionTypes.GET_CAFES_EXCEL_FILE_FAILED,
          reject: actionTypes.GET_CAFES_EXCEL_FILE_REJECT,
        });
        dispatch(errAction);

        throw err;
      });
  };
};
